<template>
  <div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="低价产品" name="first">
        <priceDow></priceDow>
      </el-tab-pane>


      <!--<el-tab-pane label="配置管理" name="second">配置管理</el-tab-pane>-->
    </el-tabs>
  </div>
</template>
<script>
// 引用priceDow.vue 组件
import priceDow from "./lib/pricedow.vue";

export default {
  components: {
    priceDow,
  },
  data() {
    return {
      activeName: "first",
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>
<style lang="scss" scoped>
.el-tabs__header {
  padding: 0 20px;
}
</style>